import type { FeatureModule } from '@/app/contract';
import { lazy, Suspense } from 'react';
import { createElement } from 'react';
import { Phone, Video } from 'lucide-react';
import { APP_ROUTES, newCallPath } from '@/app/paths';
import { registerNamespace } from '@/i18n';
import { registerChatAccessory, registerPartRenderer } from '@/features/chat/registry';
import { CallHeaderActions } from './components/CallHeaderActions';
import { CallRecordPart } from './public';
import en from './locales/en.json';
import zh from './locales/zh-Hans.json';

registerNamespace('calls',{en,'zh-Hans':zh});
registerChatAccessory('header',CallHeaderActions);
registerPartRenderer('system:call',CallRecordPart);
const NewCall=lazy(()=>import('./routes/NewCallRoute'));
const Call=lazy(()=>import('./routes/CallRoute'));
const route=(component:typeof NewCall)=>()=>createElement(Suspense,{fallback:null},createElement(component));

/** Calls supplies lazy routes, commands, locales and chat extension registrations. */
const feature: FeatureModule = { id: 'calls', routes: [{...APP_ROUTES.newCall,component:route(NewCall)},{...APP_ROUTES.call,component:route(Call)}],commands:[
  {id:'calls.voice',titleKey:'calls:command.voice',icon:Phone,run:nav=>nav.open(newCallPath(nav.section,{kind:'voice'}))},
  {id:'calls.video',titleKey:'calls:command.video',icon:Video,run:nav=>nav.open(newCallPath(nav.section,{kind:'video'}))},
] };
export default feature;
export { CallsHost, CallRecordPart, callRecordText } from './public';
